import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

export type RwcDevToolFeatures = RwcDevToolFeature<RwcDevToolFeatureKind.RwcLocalBackend>;

export const enum RwcDevToolFeatureKind {
    RwcLocalBackend
}

export interface RwcDevToolFeature<FeatureKind extends RwcDevToolFeatureKind> {
    kind: FeatureKind;
    providers: EnvironmentProviders[];
}

export function rwcDevToolFeature<FeatureKind extends RwcDevToolFeatureKind>(
    kind: FeatureKind,
    providers: EnvironmentProviders[]
): RwcDevToolFeature<FeatureKind> {
    return {
        kind,
        providers
    };
}

export function provideRwcAzureDevTools(...features: RwcDevToolFeatures[]): EnvironmentProviders {
    return makeEnvironmentProviders(features.flatMap(feature => feature.providers));
}
